import Layout from '../../layout';

const customRouter = {
	path: '/custom', // 明确路径为 /custom
	component: Layout,
	name: 'custom',
	meta: {
		title: 'Custom Page',
		sort: 4,
	},
	children: [
		{
			path: '', // 默认子路由，匹配 /custom
			component: () =>
				import('@/pages/ideological/views/home/CustomIndex.vue'),
			name: 'custom',
			meta: { title: 'Custom Home' },
		},
		{
			path: 'specialTopic',
			component: () =>
				import('@/pages/ideological/views/specialTopic/index.vue'),
			name: 'custom',
		},
		{
			path: 'hotContent',
			component: () =>
				import('@/pages/ideological/views/hotContent/index.vue'),
			name: 'custom',
		},
		{
			path: 'specialTopicNoLeft',
			component: () =>
				import(
					'@/pages/ideological/views/specialTopicNoLeft/index.vue'
				),
			name: 'custom',
		},
	],
};

export default customRouter;
